var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',[_c('kendo-dropdownlist',{staticClass:"toggle-dropdown",attrs:{"data-source":_vm.propActions,"valueTemplate":_vm.actionValueTemplate,"template":_vm.actionTemplate,"select":_vm.onSelect,"auto-width":true,"popup":{position: 'top right', origin: 'bottom right'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }